import React from "react";

import * as SC from "./CampaignLocation.styled";
import Section from "../Section/Section";

const CampaignLocation = ({ locations }) => {
  let location = "";
  if (locations) {
    location = locations.map((locCampaign) => locCampaign.location).join(", ");
  }

  return (
    <Section title={"Standorte"}>
      <SC.Locations>{location}</SC.Locations>
    </Section>
  );
};

export default CampaignLocation;
